import React from "react";
import "../styles/keyfeatures.css";

const KeyFeatures = () => {
  return (
    <section className="key-features-section">
      <div className="key-features-container">
      <div className="key-features-text-frame">
        <h2 className="key-features-heading">Key Features</h2>
        <p className="key-features-description">
          Simplify operations with our efficient, <br />quality, swift-focused services.
        </p>
        </div>
        {/* Grid containing all three cards */}
        <div className="key-features-grid">
          {/* First Card */}
          <div className="feature-card">
            <div className="feature-content">
              <img src="/tracking-icon.svg" alt="Tracking Icon" className="feature-icon" />
              <div className="feature-text">
                <h3 className="feature-title">Real-Time Tracking</h3>
                <p className="feature-description">
                  Stay updated on your package's journey
                  <br className="desktop-break" /> 
                  <br className="mobile-break" />  with live tracking features.
                </p>
              </div>
            </div>
          </div>

          {/* Second Card */}
          <div className="feature-card">
            <div className="feature-content">
              <img src="/secure-icon.svg" alt="Secure Handling" className="feature-icon" />
              <div className="feature-text">
                <h3 className="feature-title">Secure Handling</h3>
                <p className="feature-description">
                  Your items are treated with utmost
                  <br className="desktop-break" /> 
                   <br className="mobile-break" /> care, guaranteeing safe delivery.
                </p>
              </div>
            </div>
          </div>

          {/* Third Card */}
          <div className="feature-card">
            <div className="feature-content">
              <img src="/delivery-icon.svg" alt="Timely Delivery" className="feature-icon" />
              <div className="feature-text">
                <h3 className="feature-title">Timely Delivery</h3>
                <p className="feature-description">
                  Count on us for prompt and reliable
                  <br className="desktop-break" /> 
                  <br className="mobile-break" /> delivery that keeps you on track.
                </p>
              </div>
            </div>
          </div>

        </div> {/* End of .key-features-grid */}
      </div>
    </section>
  );
};

export default KeyFeatures;
